/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StudiengangInputs */

const en__field_studiengang = /** @type {(inputs: _Field_StudiengangInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course of Study`)
};

const de__field_studiengang = /** @type {(inputs: _Field_StudiengangInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studiengang`)
};

/**
* | output |
* | --- |
* | "Course of Study" |
*
* @param {_Field_StudiengangInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_studiengang = /** @type {((inputs?: _Field_StudiengangInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StudiengangInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_studiengang(inputs)
	return de__field_studiengang(inputs)
});